'use strict';

/**
 *
 * @name: nownessApp.modules
 *
 */

import BrandLiveDirective from './nn-brand-live/nn-brand-live.directive';
import BrandStoriesDirective from './nn-brand-stories/nn-brand-stories.directive';
import EcommerceDirective from './nn-ecommerce/nn-ecommerce.directive';
import EditorialDirective from './nn-editorial/nn-editorial.directive';
import FollowUsDirective from './nn-follow-us/nn-follow-us.directive';
import NnSocialExtended from './nn-social-extended/nn-social-extended.directive';
import GroupEditorialDirective from './nn-group-editorial/nn-group-editorial.directive';
import JoinUsDirective from './nn-join-us/nn-join-us.directive';
import NnLiveEventDirective from './nn-live-event/nn-live-event.directive';

// Series
import AllSeriesExtendedDirective from './series/nn-all-series-extended/nn-all-series-extended.directive';
// import AllSeriesDirective from './series/nn-all-series/nn-all-series.directive';
import CoverSeriesExtendedDirective from './series/nn-cover-series-extended/nn-cover-series-extended.directive';
import CoverSeriesDirective from './series/nn-cover-series/nn-cover-series.directive';
import SeriesGroupExtendedDirective from './series/nn-series-group-extended/nn-series-group-extended.directive';
import SeriesGroupDirective from './series/nn-series-group/nn-series-group.directive';
import SingleSeriesExtendedDirective from './series/nn-single-series-extended/nn-single-series-extended.directive';
import SingleSeriesDirective from './series/nn-single-series/nn-single-series.directive';
import NnSeriesSwiperDirective from './series/common-components/nn-series-swiper/nn-series-swiper.directive';

// Seasons
import AllSeasonsExtendedDirective from './seasons/nn-all-seasons-extended/nn-all-seasons-extended.directive';
import CoverSeasonsExtendedDirective from './seasons/nn-cover-seasons-extended/nn-cover-seasons-extended.directive';
import CoverSeasonsDirective from './seasons/nn-cover-seasons/nn-cover-seasons.directive';
import SeasonsGroupExtendedDirective from './seasons/nn-seasons-group-extended/nn-seasons-group-extended.directive';
import SeasonsGroupDirective from './seasons/nn-seasons-group/nn-seasons-group.directive';
import SingleSeasonsExtendedDirective from './seasons/nn-single-seasons-extended/nn-single-seasons-extended.directive';
import SingleSeasonsDirective from './seasons/nn-single-seasons/nn-single-seasons.directive';

// Contributors
import NnAllContributorsDirective from './nn-all-contributors/nn-all-contributors.directive';
import NnContributorListDirective from './nn-contributor-list/nn-contributor-list.directive';
import NnPickedContributorsDirective from './nn-picked-contributors/nn-picked-contributors.directive';
import NnContributorsDirective from './nn-contributors/nn-contributors.directive';
import GuestPicksDirective from './nn-guest-picks/nn-guest-picks.directive';

//
import MoreToLoveDirective from './nn-more-to-love/nn-more-to-love.directive';
import MozaicDirective from './nn-mozaic/nn-mozaic.directive';
import NnXPostsDirective from './nn-x-posts/nn-x-posts.directive';
import NnXSeriesDirective from './nn-x-series/nn-x-series.directive';
import NnXSopicsDirective from './nn-x-topics/nn-x-topics.directive';
import PlainTextDirective from './nn-plain-text/nn-plain-text.directive';
import PostGroupDirective from './nn-post-group/nn-post-group.directive';
import SearchButtonDirective from './nn-search-button/nn-search-button.directive';
import SuggestionsGroupDirective from './nn-suggestions-group/nn-suggestions-group.directive';
import NnGoogleAdDirective from './nn-google-ad/nn-google-ad.directive.js';
import NnNewsletterDirective from './nn-newsletter/nn-newsletter.directive.js';
import NnPostsExpandSwiperDirective from './common-components/nn-posts-expand-swiper/nn-posts-expand-swiper.directive'
import NnModulesDirective from './nn-modules.directive';
import ModulesAnalyticsFactory from './nn-modules-analytics.factory';
import MatchContributorByTypeFilter from './nn-match-contributor-by-type.filter';
import NnCategoriesListDirective from './nn-categories-list/nn-categories-list.directive';
import NnHonoureesDirective from './nn-honourees/nn-honourees.directive';

const ModulesModule = angular
  .module('nownessApp.modules', [])
  .directive('brandLive', BrandLiveDirective)
  .directive('brandStories', BrandStoriesDirective)
  .directive('ecommerce', EcommerceDirective)
  .directive('editorial', EditorialDirective)
  .directive('followUs', FollowUsDirective)
  .directive('groupEditorial', GroupEditorialDirective)
  .directive('joinUs', JoinUsDirective)
  .directive('nnLiveEvent', NnLiveEventDirective)
  // Series
  .directive('allSeriesExtended', AllSeriesExtendedDirective)
  // .directive('allSeries', AllSeriesDirective)
  .directive('coverSeriesExtended', CoverSeriesExtendedDirective)
  .directive('coverSeries', CoverSeriesDirective)
  .directive('seriesGroupExtended', SeriesGroupExtendedDirective)
  .directive('seriesGroup', SeriesGroupDirective)
  .directive('singleSeriesExtended', SingleSeriesExtendedDirective)
  .directive('singleSeries', SingleSeriesDirective)
  .directive('nnSeriesSwiper', NnSeriesSwiperDirective)
  // Seasons
  .directive('nnAllSeasonsExtended', AllSeasonsExtendedDirective)
  .directive('nnCoverSeasonExtended', CoverSeasonsExtendedDirective)
  .directive('nnCoverSeason', CoverSeasonsDirective)
  .directive('nnSeasonGroupExtended', SeasonsGroupExtendedDirective)
  .directive('nnSeasonGroup', SeasonsGroupDirective)
  .directive('nnSingleSeasonExtended', SingleSeasonsExtendedDirective)
  .directive('nnSingleSeason', SingleSeasonsDirective)
  // Contributors
  .directive('nnContributors', NnContributorsDirective)
  .directive('nnPickedContributors', NnPickedContributorsDirective)
  .directive('nnAllContributors', NnAllContributorsDirective)
  .directive('nnContributorList', NnContributorListDirective)
  .directive('guestPicks', GuestPicksDirective)
  //
  .directive('moreToLove', MoreToLoveDirective)
  .directive('mozaic', MozaicDirective)
  .directive('nnPostsExpandSwiper', NnPostsExpandSwiperDirective)
  .directive('nnModules', NnModulesDirective)
  .directive('nnPlainText', PlainTextDirective)
  .directive('nnXPosts', NnXPostsDirective)
  .directive('nnXSeries', NnXSeriesDirective)
  .directive('nnSocialExtended', NnSocialExtended)
  .directive('nnXTopics', NnXSopicsDirective)
  .directive('postGroup', PostGroupDirective)
  .directive('searchButton', SearchButtonDirective)
  .directive('suggestionsGroup', SuggestionsGroupDirective)
  .directive('nnGoogleAd', NnGoogleAdDirective)
  .directive('nnNewsletter', NnNewsletterDirective)
  .factory('modulesAnalytics', ModulesAnalyticsFactory)
  .directive('nnCategoriesList', NnCategoriesListDirective)
  .directive('nnHonourees', NnHonoureesDirective)
  .filter('matchContributorByType', MatchContributorByTypeFilter)

export default ModulesModule.name;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-modules.module.js